<template>
  <SuiteTopicsFaq :suite-data="contextData" />
</template>

<script setup lang="ts">
  import type { IFaq } from '@/components/Shared/Suite/TopicsFaq/index.vue';

  const { t } = useI18n({ useScope: 'local' });

  const contextData = computed(
    (): IFaq => ({
      component: 'topics-faq',
      meta: {
        navigable: '',
      },
      data: {
        sectionName: t('section-name'),
        title: t('title'),
        items: [
          {
            name: t('item-1-title'),
            description: t('item-1-description'),
          },
          {
            name: t('item-2-title'),
            description: t('item-2-description'),
          },
          {
            name: t('item-3-title'),
            description: t('item-3-description'),
          },
        ],
        direction: 'horizontal',
      },
    })
  );
</script>

<i18n lang="json">
{
  "en-int": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "en-jp": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "en-tw": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "en-kr": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "en-americas": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "en-asia-pacific": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "en-emea": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "ja-jp": {
    "section-name": "O&Mの課題",
    "title": "現代インフラ変革を促す主要なドライバー",
    "item-1-title": "分散した資産とデータのサイロ化",
    "item-1-description": "設備が複数拠点に分散し、運用・エネルギーデータが統合されていないことにより、<span class=\"font-bold text-adv_blue-400\">全体の可視性が不足し</span>、意思決定の効率に影響を与えています。",
    "item-2-title": "運用の複雑化",
    "item-2-description": "人材不足や<span class=\"font-bold text-adv_blue-400\">プロセスの標準化不足</span>に加え、対応要求の増加により、安定運用の維持と迅速な対応が困難になっています。",
    "item-3-title": "パフォーマンスと効率性への要求増大",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">突発的なダウンタイム</span>やエネルギーコストの変動、サステナビリティ要件への対応により、より高度な可視化と予測が求められています。"
  },
  "zh-cn": {
    "section-name": "Challenges",
    "title": "Why Modern Infrastructure Must Evolve",
    "item-1-title": "Dispersed Assets and Fragmented Data",
    "item-1-description": "Equipment is deployed across multiple locations, but operational and energy data remains <span class=\"font-bold text-adv_blue-400\">siloed</span>—limiting unified visibility and informed decision-making.",
    "item-2-title": "Rising Operational Complexity",
    "item-2-description": "Limited man power, <span class=\"font-bold text-adv_blue-400\">inconsistent processes</span>, and increasing response demands make it difficult to maintain stable operations and react quickly to issues across sites.",
    "item-3-title": "Higher Expectations for Performance and Efficiency",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">Unplanned downtime</span>, energy cost volatility, and sustainability targets require more proactive insight into asset health and energy usage."
  },
  "zh-tw": {
    "section-name": "維運挑戰",
    "title": "現代基礎設施轉型的關鍵驅動力",
    "item-1-title": "資產分散與數據孤島",
    "item-1-description": "設備分布於多個場域，營運與能源數據<span class=\"font-bold text-adv_blue-400\">尚未整合</span>，導致整體可視性不足，進而影響決策效率與管理品質",
    "item-2-title": "營運複雜度提升",
    "item-2-description": "人力資源有限、<span class=\"font-bold text-adv_blue-400\">流程標準化不足</span>，加上跨據點的應變需求持續增加，使得維持穩定運作與快速因應突發狀況愈發困難",
    "item-3-title": "更高的效能與效率要求",
    "item-3-description": "<span class=\"font-bold text-adv_blue-400\">突發停機</span>、能源成本波動與永續目標，促使企業需要更前瞻的設備與能源洞察"
  }
}
</i18n>
